import React from 'react';
import './Hero.css';
import heroImage from '../assets/hero_image.png';

const Hero: React.FC = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1>Hello, I'm <span className="highlight">Jordan Butler</span></h1>
          <h2>Software Developer</h2>
          <p>
            I'm a passionate developer who turns ideas into reality through code. When I'm not solving complex problems, I'm constantly learning new technologies to stay ahead of the curve. Let's build something amazing together!
          </p>
          <div className="hero-buttons">
            <button className="primary-button" onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}>
              View My Work
            </button>
            <button className="secondary-button" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
              Contact Me
            </button>
          </div>
        </div>
        <div className="hero-image">
          <div className="profile-image-container">
            <img src={heroImage} alt="Jordan Butler" className="profile-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;